<template>
  <div
    v-if="show"
    class="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
  >
    <!-- Backdrop -->
    <div
      class="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm"
      @click="$emit('close')"
    ></div>

    <!-- Modal Container -->
    <div
      class="relative z-50 w-full max-w-[600px] mx-4 sm:mx-auto my-6 flex flex-col bg-white dark:bg-secondary rounded-[16px] shadow-2xl transition-all duration-300 transform scale-100"
      @click.stop
    >
      <!-- Close Button (Absolute) -->
      <button
        @click="$emit('close')"
        class="absolute top-8 right-8 w-10 h-10 flex items-center justify-center rounded-full border border-border hover:bg-muted transition-all focus:outline-none z-10"
      >
        <X class="w-5 h-5 text-muted-foreground" />
      </button>

      <!-- Header -->
      <div class="px-8 pt-10 pb-6">
        <h2
          class="text-4xl font-bold text-foreground tracking-tight leading-tight"
        >
          {{ title }}
        </h2>
        <p
          v-if="subtitle"
          class="mt-2 text-muted-foreground text-md font-normal"
        >
          {{ subtitle }}
        </p>
      </div>

      <!-- Main Content Area -->
      <div class="px-8 pb-8 overflow-y-auto max-h-[60vh]">
        <slot />
      </div>

      <!-- Footer / Actions -->
      <div class="px-8 pb-10 pt-4 flex justify-end gap-3 items-center">
        <slot name="actions">
          <button
            type="button"
            class="px-8 py-3 bg-white border border-border text-foreground rounded-full font-semibold hover:bg-muted transition-all"
            @click="$emit('discard')"
          >
            Discard
          </button>
          <button
            type="button"
            class="px-10 py-3 bg-black dark:bg-white text-white dark:text-black rounded-full font-semibold hover:opacity-90 transition-all disabled:opacity-50"
            :disabled="loading"
            @click="$emit('save')"
          >
            <span v-if="loading" class="flex items-center gap-2">
              <Loader2 class="w-4 h-4 animate-spin" />
              Saving...
            </span>
            <span v-else>Save</span>
          </button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { X, Loader2 } from "lucide-vue-next";

export default {
  name: "ProfileModalShell",
  components: {
    X,
    Loader2,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close", "save", "discard"],
  watch: {
    show(val) {
      if (val) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    },
  },
  beforeUnmount() {
    document.body.style.overflow = "auto";
  },
};
</script>

<style scoped>
.modal-content {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.1) transparent;
}

.modal-content::-webkit-scrollbar {
  width: 6px;
}

.modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 20px;
}
</style>
